<template>
    <div class="custom-actions">
        <div class="btn-group">
            <a :href="'/adm/despesas/relatorio/'+rowData.id" target="_blank" class="btn btn-outline-success">
                <i class="fas fa-dollar-sign"></i>
            </a>
            <a :href="'/adm/rotas/diario/relatorio/'+rowData.id" target="_blank" class="btn btn-primary">
                <i class="far fa-calendar-check"></i>
            </a>
            <button class="btn btn-success" @click="getAprova(rowData.id)"><i class="far fa-thumbs-up"></i></button>
            <button class="btn btn-info" @click="edite(rowData.id)"><i class="fa fa-edit"></i></button>
            <button class="btn btn-warning" @click="delRota(rowData.id)"><i class="far fa-trash-alt"></i></button>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            rowData: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number
            }
        },
        data(){
          return {
              admin: $('#Admin').val(),
              valorTOTAL:0,
              totalCombustivel:0,
              totalkm_extra:0,
              totalLitros:0,
              qtdHospedagem:0,
              totalHospedagem:0,
              totalAlimentacao:0,
              totalKM:0,
              totalPedagio:0,
              valor_hospedagem:0,
              valor_alimentacao:0,
              valor_combustivel:0,
              parametro_id:0,
              listaRotas:[],
              rota_id:0,
              parametros: {
                  kmXdia:0,
                  kmXlitro:0,
                  kmExtra:0,
                  alimentacao:0,
                  hospedagem:0,
                  combustivel:0
              },
          }  
        },
        methods: {

            delRota:function(id){
                var vm = this;
                vm.$swal({
                    title: 'Deletar Rota.',
                    text: 'Você deseja deletar esta rota agora? esta ação não poderá ser revertida.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, deletar.',
                    cancelButtonText: 'Não!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if(result.value) {
                        axios.post('/adm/rotas/destroy',{ id: id }).then(function(response){
                            let obj = response.data;
                            if(obj.success){
                                vm.$swal('Ok',obj.success,'success');
                                //vm.getLoad();
                                vm.$events.fire('get-load');
                            }

                        }).catch(function(error){
                            console.log(error.response);
                        });
                    }
                })
            },

            edite:function(id){
                window.location.href='/adm/rotas/edit/'+id;
            },

            getAprova:function(id){
                this.$events.fire('get-aprova', id);
            },

        },
    }
</script>

<style>
    .custom-actions button.ui.button {
        padding: 8px 8px;
    }
    .custom-actions button.ui.button > i.icon {
        margin: auto !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/rotas/table/RotasActions.vue